import { render, staticRenderFns } from "./ProcessesMetricsTableMobile.vue?vue&type=template&id=2ca95a8d&scoped=true"
import script from "./ProcessesMetricsTableMobile.ts?vue&type=script&lang=ts&external"
export * from "./ProcessesMetricsTableMobile.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessesMetricsTableMobile.vue?vue&type=style&index=0&id=2ca95a8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca95a8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca95a8d')) {
      api.createRecord('2ca95a8d', component.options)
    } else {
      api.reload('2ca95a8d', component.options)
    }
    module.hot.accept("./ProcessesMetricsTableMobile.vue?vue&type=template&id=2ca95a8d&scoped=true", function () {
      api.rerender('2ca95a8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/ProcessesTableSection/ProcessesMetricsTableMobile/ProcessesMetricsTableMobile.vue"
export default component.exports